import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import RequestAccessStepOne from 'components/Signup/RequestAccessStepOne'
import RequestAccessStepTwo from 'components/Signup/RequestAccessStepTwo'
import { resetAuthError, authFail } from 'store/actions'
import history from 'utils/appHistory'

import BgLoginImg from 'assets/woman.jpg'
import LogoLoginImg from 'assets/logo_tr.png'

const accessSteps = {
  one: RequestAccessStepOne,
  two: RequestAccessStepTwo,
}

const RequestAccessPage = (props) => {
  const [scaleClassIsSet, setScaleClassIsSet] = useState(false)
  const [accessStep, setAccessStep] = useState('one')

  useEffect(() => {
    document.documentElement.classList.add('no_scale_mod')
    setScaleClassIsSet(true)
    return
  }, [])

  const RequestAccessStep = accessSteps[accessStep]

  const showWelcomeVideo = props.attributes?.permissions?.features?.alwaysOnWelcomeVideo

  const redirectPath =
    showWelcomeVideo && !props.isDoctor
      ? `/welcome`
      : props.isDoctor
      ? `/welcome-doctor`
      : '/indication-select'

  return (
    <section className="section login_mod">
      {props.isAuthenticated && history.location.path !== redirectPath ? (
        <Redirect to={redirectPath} />
      ) : null}
      {scaleClassIsSet && (
        <>
          <div className="section_bg login_mod">
            <img className="section_bg_img" src={BgLoginImg} alt="section background" />
          </div>
          <div className="section_in login_mod">
            <div className="logo login_mod">
              <img className="logo_img" src={LogoLoginImg} alt="logo" />
            </div>
            <RequestAccessStep
              setAccessStep={(newAccessStep) => {
                Object.keys(accessStep).includes(newAccessStep)
                setAccessStep(newAccessStep)
              }}
              authFail={props.authFail}
              resetAuthError={props.resetAuthError}
            />
          </div>
        </>
      )}
    </section>
  )
}

const mapStateToProps = ({
  auth: { attributes, error, loading, isAuthenticated, isDoctor },
}) => {
  return {
    attributes,
    loading,
    isAuthenticated,
    isDoctor,
    authError: error,
  }
}

const willMapDispatchToProps = {
  authFail,
  resetAuthError,
}

export default connect(mapStateToProps, willMapDispatchToProps)(RequestAccessPage)
